import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

export default function AppImage({src, alt = "image", effect="blur", className="img-fluid", ...props}) {
    return  <LazyLoadImage alt={alt} effect={effect} src={src} wrapperClassName={className} {...props}/>
}
